import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('errorLogStore', Object.keys(state)),
	...mapGetters('errorLogStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('errorLogStore', Object.keys(actions)),
	...mapMutations('errorLogStore', Object.keys(mutations))
};
